var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.83 20.1997H14.3477C14.7079 20.1997 14.9999 19.9077 14.9999 19.5475V5.13919L14.4927 4.6084H18.5258L22.0039 8.08643V21.3475C22.0039 21.7077 21.7119 21.9997 21.3517 21.9997H11.4821C11.1219 21.9997 10.83 21.7077 10.83 21.3475V20.1997Z",
    fill: "#B35F9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.526 8.08666V4.6084L22.0043 8.08666H18.526Z",
    fill: "#C88CB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2.65217C2 2.29199 2.29199 2 2.65217 2H14.1739L10.6958 2L14.1739 5.47813V18.7391C14.1739 19.0993 13.8819 19.3913 13.5217 19.3913H2.65217C2.29199 19.3913 2 19.0993 2 18.7391V2.65217ZM8.63748 11.7702L9.37801 11.0552C9.60386 10.8379 9.96306 10.8441 10.1804 11.0694C10.3983 11.2952 10.3921 11.6544 10.1668 11.8718L8.46441 13.5157C8.35375 13.6212 8.21189 13.6746 8.07002 13.6746C7.92475 13.6746 7.77948 13.6195 7.66883 13.5083L5.96646 11.8059C5.74458 11.5846 5.74458 11.2254 5.96646 11.0036C6.18776 10.7822 6.54696 10.7822 6.76884 11.0036L7.50256 11.7373V8.56746C7.50256 8.25365 7.75679 8 8.07002 8C8.38326 8 8.63748 8.25365 8.63748 8.56746V11.7702Z",
    fill: "#7CB141"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6957 5.47826V2L14.1739 5.47826H10.6957Z",
    fill: "#ABD977"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/Resources.9d900ebcd954fa12dd35cdb4964d1733.svg";
export { ForwardRef as ReactComponent };